import ApiAuth from './ApiAuth'

export const Imports = {
    reports(context, queryParams) {
        return new Promise((resolve, reject) => {
            ApiAuth().get(`report${queryParams}`).then(response => {
                resolve(response.data);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    report(context, data) {
        return new Promise((resolve, reject) => {
            ApiAuth().get(`import/${data.id}${data.queryParams}`).then(response => {
                resolve(response.data);
            }).catch((error) => {
                reject(error.response);
            });
        });
    }
};